/**
 * Created by AlexanderC on 6/15/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationSchemaNotFoundException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let ValidationSchemaNotFoundException = exports.ValidationSchemaNotFoundException = function (_Exception) {
  _inherits(ValidationSchemaNotFoundException, _Exception);

  /**
   * @param {String} schemaName
   */
  function ValidationSchemaNotFoundException(schemaName) {
    _classCallCheck(this, ValidationSchemaNotFoundException);

    return _possibleConstructorReturn(this, (ValidationSchemaNotFoundException.__proto__ || Object.getPrototypeOf(ValidationSchemaNotFoundException)).call(this, `Missing validation schema '${schemaName}'`));
  }

  return ValidationSchemaNotFoundException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-validation/lib.compiled/Exception/ValidationSchemaNotFoundException.js
// module id = 459
// module chunks = 0